export interface AttendanceRecord {
    id: number;
    employeeId: number;
    startTime: string;
    endTime: string | null;
    status: number;
    actualHours: number;
    source?: string;
}

export interface AttendanceSummary {
    averageHoursPerDay: number;
    leaveOrOtherPercent: number;
    presencePercent: number;
    records: AttendanceRecord[];
}

export interface props {
    attendanceData: AttendanceSummary | null;
}

export const attendanceHeaders = [
    { id: 1, name: "S. No" },
    { id: 2, name: "Date" },
    { id: 3, name: "Check-In" },
    { id: 4, name: "Check-Out" },
    { id: 5, name: "Status" },
    { id: 6, name: "Source" },
];
